import { defineMessages } from 'react-intl';

export default defineMessages({
    nonIAorPCSFutureRenewalMessage: {
        id: 'ml.policychange.confirmationPolChange.Non IA or PCS Future Renewal and Applied Forward Message',
        defaultMessage: 'Action needed. The change has been processed for the current term. However, we were unable to apply it on the renewal term. Please contact us to have the change manually processed on the renewal.'
    },
    iAorPCSFutureRenewalMessage: {
        id: 'ml.policychange.confirmationPolChange.IA or PCS Future Renewal and Applied Forward Message',
        defaultMessage: 'Action needed. The change has been processed for the current term. However, we were unable to apply it on the renewal term. Please contact us at 1-800-255-0332 to have the change manually processed on the renewal.'
    },
    accountHasUmbrellaPolicy: {
        id: 'ml.policychange.confirmationPolChange.account Has Umbrella Policy',
        defaultMessage: 'Please be sure to also update any changes made to the liability limits or qualification questions causing an exclusion on the umbrella policy'
    },
    typePolicy: {
        id: 'ml.policychange.confirmationPolChange.Type Policy',
        defaultMessage: '{policyType} Policy'
    },
    printConfirmation: {
        id: 'ml.policychange.confirmationPolChange.Print Confirmation',
        defaultMessage: 'Print Confirmation'
    },
    goToAccount: {
        id: 'ml.policychange.confirmationPolChange.Go To Account',
        defaultMessage: 'Go To Account'
    },
    change : {
        id: 'ml.policychange.confirmationPolChange.change',
        defaultMessage: 'Change'
    },
    coverageDocumentUppercase: {
        id: 'ml.policychange.confirmationPolChange.COVERAGE DOCUMENT',
        defaultMessage: 'COVERAGE DOCUMENT'
    },
    actionUppercase: {
        id: 'ml.policychange.confirmationPolChange.ACTION',
        defaultMessage: 'ACTION'
    },
    yourPolicyDocuments: {
        id: 'ml.policychange.confirmationPolChange.Your Policy Documents',
        defaultMessage: 'Your Policy Documents'
    },
    send: {
        id: 'ml.policychange.confirmationPolChange.Send',
        defaultMessage: 'Send'
    },
    policychangeconfirmation : {
        id: 'ml.policychange.confirmationPolChange.Policy Change Confirmation',
        defaultMessage: 'Policy Change Confirmation'
    },
    view: {
        id: 'ml.policychange.confirmationPolChange.View',
        defaultMessage: 'View'
    },
    yourIDCards: {
        id: 'ml.policychange.confirmationPolChange.Your ID Cards',
        defaultMessage: 'Your ID Cards'
    },
    hoAccountHasUmbrellaPolicy: {
        id: 'ml.policychange.confirmationPolChange.ho account Has Umbrella Policy',
        defaultMessage: 'Please be sure to also update any changes made to the liability limits or qualification questions causing an exclusion on the umbrella policy'
    },
    paAccountHasUmbrellaPolicy: {
        id: 'ml.policychange.confirmationPolChange.pa account Has Umbrella Policy',
        defaultMessage: 'Please be sure to also update any changes made to vehicles, drivers, boats and liability limits on the umbrella policy.'
    },
    contingenciesTitle: {
        id: 'ml.policychange.confirmationPolChange.Next steps: Submit required documentation',
        defaultMessage: 'Next steps: Submit required documentation'
    },
    contingenciesHeader: {
        id: 'ml.policychange.confirmationPolChange.You must submit supporting documentation for the following:',
        defaultMessage: 'You must submit supporting documentation for the following:'
    },
    effectiveDate: {
        id: 'ml.policychange.confirmationPolChange.Your policy change will be effective',
        defaultMessage: 'Your policy change will be effective'
    },
    effectiveDateMsg: {
        id: 'ml.policychange.confirmationPolChange.effectiveDateMsg',
        defaultMessage: '{effectiveDate} {date}.'
    },
    variousSupplementaryDocuments: {
        id: 'ml.policychange.confirmationPolChange.Various supplementary documents related to your policy.',
        defaultMessage: 'Various supplementary documents related to your policy.'
    },  
    viewAndPrintYourIDCards: {
        id: 'ml.policychange.confirmationPolChange.View and print your ID Cards',
        defaultMessage: 'View and print your ID Cards'
    },
    viewButton: {
        id: 'ml.policychange.confirmationPolChange.VIEW button',
        defaultMessage: 'VIEW'
    },
    viewAndPrintButton: {
        id: 'ml.policychange.confirmationPolChange.VIEW AND PRINT',
        defaultMessage: 'VIEW AND PRINT'
    },
    downloadingDocument: {
        'id': 'ml.policychange.confirmationPolChange.Downloading document...',
        'defaultMessage': 'Downloading document...'
    },
    documentDownloadErrorHeader: {
        'id': 'ml.policychange.confirmationPolChange.Error',
        'defaultMessage': 'Error'
    },
    documentDownloadErrorMessage: {
        'id': 'ml.policychange.confirmationPolChange.Were sorry. We were unable to download your document, please try again.',
        'defaultMessage': 'We\'re sorry. We were unable to download your document, please try again.'
    },
    loading: {
        'id': 'ml.policychange.confirmationPolChange.Loading',
        'defaultMessage': 'Loading...'
    },
});
